import { Node, mergeAttributes } from '@tiptap/core';

// an inline switch: it prints nothing, and the line holding it prints only
// when the named custom field has the given value (any value when none is set)
export const ConditionNode = Node.create({
  name: 'condition',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      name: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-condition') || '',
        renderHTML: (attributes) => ({ 'data-condition': attributes.name }),
      },
      equals: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-condition-equals') || '',
        renderHTML: (attributes) =>
          attributes.equals ? { 'data-condition-equals': attributes.equals } : {},
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-condition]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    const name = node.attrs.name || 'Field';
    const label = node.attrs.equals ? `if ${name} = ${node.attrs.equals}` : `if ${name} is filled`;
    return ['span', mergeAttributes(HTMLAttributes, { class: 'agreement-condition' }), label];
  },
});
